import NotFound from '@/components/errors/404';

export default function NotFoundPage() {
  return <NotFound />;
}
